"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PercentageInput = void 0;
var core_ui_1 = require("@newfront-insurance/core-ui");
var react_1 = __importDefault(require("react"));
function PercentageInput(_a) {
    var value = _a.value, onChange = _a.onChange;
    return react_1.default.createElement(core_ui_1.Input, { type: "number", value: value, onChange: function (inputValue) { return onChange(inputValue); }, appendText: "%" });
}
exports.PercentageInput = PercentageInput;
